import { Card } from '@app/components/various/Card';
import { getIsAccountEditingEnabled } from '@app/ducks';
import { useGetShippingAddressOptions } from '@app/utils/hooks/accounts/useGetShippingAddressOptions';
import { isEmpty } from '@app/utils/isEmpty';
import { Addresses } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  accountId: string;
  shippingAddresses: Addresses.Shipping[];
  isLoading?: boolean;
  shippingAddress: Addresses.Shipping;
  onEdit: (shippingAddressId: string) => void;
}

export const ShippingAddressCard = ({ accountId, shippingAddresses, shippingAddress, isLoading = false, onEdit }: Props) => {
  const { t } = useTranslation(['buyers', 'common']);
  const isAccountEditingEnabled = useSelector(getIsAccountEditingEnabled);

  const {
    shippingAddress: shippingAddressId = '',
    company = '',
    contactPerson = '',
    address1,
    address2,
    city,
    countryName,
    stateName,
    email = '',
    phoneNumber = '',
    zipCode,
  } = shippingAddress;

  const getOptions = useGetShippingAddressOptions({ accountId, onEdit, shippingAddresses });

  return (
    <Card.Wrapper variant="gray" className="pr-10">
      {((typeof company === 'string' && !isEmpty(company)) || isLoading) && <Card.Title isLoading={isLoading}>{company}</Card.Title>}
      <Card.AttributeList isLoading={isLoading} skeletonRows={4}>
        <Card.Attribute name={t('common:contact_person')} value={contactPerson} />
        <Card.AttributeLink name={t('common:email')} value={email} to={`mailto:${email}`} />
        <Card.Attribute name={t('common:phone')} value={phoneNumber} />
        <Card.Attribute
          name={t('common:address')}
          value={
            <span data-sentry-mask>{[address1, address2, city, stateName, zipCode, countryName].filter(Boolean).join(', ') || '-'}</span>
          }
        />
      </Card.AttributeList>
      {isAccountEditingEnabled && (
        <Card.Menu title={t('buyers:address_options')} items={getOptions(shippingAddressId)} isDisabled={isLoading} />
      )}
    </Card.Wrapper>
  );
};
